import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=6c5e6f5a"
import script from "./confirm.vue?vue&type=script&lang=ts"
export * from "./confirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports